/**
 * The amounts a donor is actually offered — ONE source.
 *
 * Every surface that puts a figure in front of a supporter reads this: the
 * donate form's preset buttons, and the supporter card on the fund page. A
 * second literal anywhere is how a page ends up naming a number the form does
 * not offer, which is the same class of defect as a "free" claim on a paid
 * product.
 */
export const PRESET_AMOUNTS = [10, 25, 50, 100];

/** The currency those presets are charged in — matches DonationForm's default. */
export const PRESET_CURRENCY = 'usd';

/**
 * "$10 · $25 · $50 · $100" — built from PRESET_AMOUNTS, never typed out, and
 * separator-only so it needs no translation.
 */
export function formatPresetAmounts(): string {
  return PRESET_AMOUNTS.map((a) => `$${a}`).join(' · ');
}
